import React from 'react';
import { Reveal } from './Reveal';
type SectionProps = {
  id?: string;
  children: React.ReactNode;
  className?: string;
  /** Adds the hairline that separates one section from the next. */
  ruled?: boolean;
  'aria-labelledby'?: string;
  'aria-label'?: string;
};

/** Section shell: consistent vertical rhythm inside the 1240px grid. */
export function Section({
  id,
  children,
  className = '',
  ruled = false,
  ...rest
}: SectionProps) {
  return <section id={id} className={`section ${ruled ? 'rule-top' : ''} ${className}`} {...rest} data-id="element-273" data-mp="35x1or53sahx4">
      <div className="shell" data-id="element-274" data-mp="3evn3sqa1ret5">{children}</div>
    </section>;
}
type SectionHeadProps = {
  eyebrow?: string;
  title: React.ReactNode;
  titleId?: string;
  intro?: string;
  action?: React.ReactNode;
  level?: 'h2' | 'h3';
};

/** The one section header used everywhere: eyebrow, heading, optional intro and action. */
export function SectionHead({
  eyebrow,
  title,
  titleId,
  intro,
  action,
  level = 'h2'
}: SectionHeadProps) {
  const Heading = level;
  return <Reveal className="flex flex-col gap-6 pb-12 md:flex-row md:items-end md:justify-between md:gap-12 md:pb-16" data-id="element-275" data-mp="24n2yoyrdsua3">
      <div className="max-w-[22ch]" data-id="element-276" data-mp="29i06k2cxcxle">
        {eyebrow && <p className="t-label mb-5 text-accent" data-id="element-277" data-mp="2einw0jli96di">{eyebrow}</p>}
        <Heading id={titleId} className="t-h2 text-balance" data-id="element-278" data-mp="2jao4j0fn57lp">
          {title}
        </Heading>
      </div>
      {(intro || action) && <div className="flex flex-col items-start gap-5 md:max-w-[38ch] md:items-end" data-id="element-279" data-mp="2o8pij6y7mgqb">
          {intro && <p className="t-body text-mut md:text-right" data-id="element-280" data-mp="2s99hmg2cfuf3">{intro}</p>}
          {action}
        </div>}
    </Reveal>;
}